export function FirstPostIntro() {
  return (
    <div className="mb-7">
      <h2 className="onboarding-display text-[2.1rem] sm:text-5xl">
        We gathered the ingredients for your first post.
      </h2>
      <p className="mt-4 text-base leading-relaxed text-muted-foreground sm:text-lg">
        You can find more ideas in your workspace.
      </p>
    </div>
  );
}
